// extracted by mini-css-extract-plugin
module.exports = {"container":"ChooseGoods_container__13mWp","goodsContent":"ChooseGoods_goodsContent__3b6HZ"};